import "./BookNow.module.css";
import Header from "@/reusable_sections/Header";
import MangomintBookingWidget from "./sections/MangomintBookingWidget";
import Footer from "@/reusable_sections/Footer";
export default function BookNowPage() {
  return <div>
      <Header />
      <MangomintBookingWidget />
      <Footer />
    </div>;
}